import { Link } from 'react-router-dom'
import { LanguageSelector } from '../../shared/i18n/LanguageSelector'
import { useLocale } from '../../shared/i18n/LocaleContext'

export function LegalPage({document}:{document:'terms'|'privacy'}) {
  const {t}=useLocale()
  if(document==='privacy') return <iframe title="Política de Privacidade — Spectra Guard AI" src="/app-privacy.html" style={{border:0,width:'100%',height:'100dvh',display:'block'}}/>
  const title=document==='terms'?t('terms'):t('privacy')
  const body=document==='terms'?t('termsBody'):t('privacyBody')
  return <main className="legal-page"><article><header className="legal-page-header"><Link className="legal-brand" to="/"><img src="/logo.png" alt="" /> Spectra Guard AI</Link><LanguageSelector compact/></header><h1>{title}</h1><div className="legal-warning">{t('draftWarning')}</div><p>{body}</p><Link className="landing-primary" to="/">{t('back')}</Link></article></main>
}
